const ToolsPage = () => {
  return (
    <div>
      <h1>Засоби</h1>
      <p>Управління засобами системи.</p>
    </div>
  )
}

export default ToolsPage
